import React from "react";

export default function BathLinen() {
  return (
   <div className="hospitality-page">

          <div
        className="hospitality-hero"
        style={{ backgroundImage: "url(/about-hero.jpg)" }}
      >
        <div className="hospitality-hero-overlay">
          <h1>Bath Linen</h1>
        </div>
        </div>

          {/* Content Section */}
      <div className="hospitality-content container">
          <p>
          All custom-made styles and eventual options are tailored from yardage, within short delays. Various widths available.
        </p>

        <h3>BATH TOWELS</h3>
          <ul>
            <li><strong>Material:</strong> 100% combed cotton / 16s/1 yarn weave</li>
            <li><strong>Weight:</strong> 400 / 600 / 800 gms / Customed Weights</li>
            <li><strong>Sizes:</strong> Customed Sizes</li>
            <li><strong>Design:</strong>
                <ul>
                    <li>Two embroidery lines</li>
                    <li>Plain</li>
                    <li>Dobby</li>
                    <li>Customed Designs</li>
                </ul>
            </li>
            <li><strong>Colors:</strong> Plain white</li>
          </ul>

          <img src="/wash_instruction.jpg" alt="Wash Instruction" />


            <h3>HAND TOWELS</h3>
            <ul>
              <li><strong>Material:</strong> 100% combed cotton / 16s/1 yarn weave</li>
              <li><strong>Weight:</strong> 400 / 600 / 800 gms / Customed Weights</li>
              <li><strong>Sizes:</strong> Customed Sizes</li>
              <li><strong>Design:</strong>
                  <ul>
                      <li>Two embroidery lines</li>
                      <li>Plain</li>
                      <li>Dobby</li>
                      <li>Customed Designs</li>
                  </ul>
              </li>
              <li><strong>Colors:</strong> Plain white</li>
            </ul>

            <img src="/wash_instruction.jpg" alt="Wash Instruction" />


            <h3>FACE TOWEL</h3>
<ul>
  <li><strong>Material:</strong> 100% combed cotton / 21s/2 yarn weave</li>
  <li><strong>Weight:</strong> 400 / 600 / 800 / 1000 gms / Customed Weights</li>
  <li><strong>Sizes:</strong> Customed Sizes</li>
  <li><strong>Design:</strong>
      <ul>
          <li>Two embroidery lines</li>
          <li>Plain</li>
          <li>Dobby</li>
          <li>Customed Designs</li>
      </ul>
  </li>
  <li><strong>Colors:</strong> Plain white</li>
</ul>

<img src="/wash_instruction.jpg" alt="Wash Instruction" />


<h3>BATH ROBE</h3>
<ul>
  <li><strong>Material:</strong> 100% velour cotton, shawl collar style</li>
  <li><strong>Weight:</strong> 400 / 600 / 800 / 1000 gms / Customed Weights</li>
  <li><strong>Sizes:</strong> L - 120 cm length, 1/2 chest: 65 cm, sleeve: 53 cm</li>
  <li><strong>Design:</strong>
      <ul>
          <li>Two embroidery lines</li>
          <li>Plain</li>
          <li>Dobby</li>
          <li>Customed Designs</li>
      </ul>
  </li>
  <li><strong>Colors:</strong> Plain white</li>
</ul>

<img src="/wash_instruction.jpg" alt="Wash Instruction" />


<h3>POOL TOWELS</h3>
<ul>
  <li><strong>Material:</strong> 100% combed cotton / 21s/2 yarn weave</li>
  <li><strong>Weight:</strong> 400 / 600 / 800 / 1000 gms / Customed Weights</li>
  <li><strong>Sizes:</strong> Customed Sizes</li>
  <li><strong>Design:</strong>
      <ul>
          <li>Two embroidery lines</li>
          <li>Plain</li>
          <li>Dobby</li>
          <li>Customed Designs</li>
      </ul>
  </li>
  <li><strong>Colors:</strong> Plain white</li>
</ul>

<img src="/wash_instruction.jpg" alt="Wash Instruction" />


<h3>BATH MAT</h3>
<ul>
  <li><strong>Material:</strong> 100% combed cotton / 21s/2 yarn weave</li>
  <li><strong>Weight:</strong> 400 / 600 / 800 / 1000 gms / Customed Weights</li>
  <li><strong>Sizes:</strong> Customed Sizes</li>
  <li><strong>Design:</strong>
      <ul>
          <li>Two embroidery lines</li>
          <li>Plain</li>
          <li>Dobby</li>
          <li>Customed Designs</li>
      </ul>
  </li>
  <li><strong>Colors:</strong> Plain white</li>
</ul>

<img src="/wash_instruction.jpg" alt="Wash Instruction" />


        
        </div>
      

</div>
  );
}
